import styled from '@emotion/styled';

/* ── styled components ── */

const Section = styled.section`
	background-color: #f3f4f6;
	color: black;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 1.5rem;
	padding-bottom: 1.5rem;
	@media (max-width: 767px) {
		display: none;
	}
`;

const Heading = styled.div`
	text-transform: uppercase;
	font-weight: 500;
	font-size: 1.5rem;
	line-height: 2rem;
	letter-spacing: 0.3em;
	text-align: center;
	padding-top: 3rem;
	padding-bottom: 3rem;
	@media (min-width: 768px) {
		font-size: 2.25rem;
		line-height: 2.5rem;
	}
`;

const Body = styled.div`
	max-width: 48rem;
	font-size: 1.25rem;
	line-height: 2rem;
`;

export default function WysiwygBlockEta({ description }: { description: string }) {
	return (
		<Section id="description">
			<Heading>Description</Heading>
			<Body>{description}</Body>
		</Section>
	);
}
